import { observer } from 'mobx-react-lite'
import { type FC } from 'react'
import classnames from 'classnames'
import Highlighter from 'react-highlight-words'
import {
  DropdownCard,
  EnumDropdownItemVariant,
  type IDropdownItem,
  InputCheckbox,
  type InputCheckboxProps,
  type ITooltipProps,
  Typography,
  Icon,
} from 'shared/ui'
import { type Phone } from 'entities/Phone/model/Phone'
import styles from './styles.module.scss'

type IPhoneDropdownCardProps = {
  item: Phone
  InputCheckboxProps?: InputCheckboxProps
  onChange?: (item: Phone) => void
  highlighter?: string
  ariaLabel?: string
  tooltipProps?: ITooltipProps
  disabled?: boolean
}

export const PhoneDropdownCard: FC<IPhoneDropdownCardProps> = observer(
  ({ item, onChange, InputCheckboxProps, highlighter, ariaLabel, tooltipProps, disabled }) => {
    const renderContent = (isCheckbox: boolean) => {
      return (
        <div
          className={classnames(styles.wrap, {
            [styles['wrap--checkbox']]: isCheckbox,
          })}
        >
          <Typography variant={'body-md-regular'} ariaLabel={'number'} className={styles.title}>
            {highlighter ? (
              <Highlighter
                highlightClassName={classnames(styles.highlighter, styles['highlighter--number'])}
                className={styles.number}
                searchWords={highlighter.split(' ')}
                autoEscape={true}
                textToHighlight={item.formatted_number}
              />
            ) : (
              item.formatted_number
            )}
          </Typography>
          {item.is_aircall && <Icon icon={'aircall'} className={styles.icon} />}
        </div>
      )
    }
    const dropdown: IDropdownItem = {
      id: item.id,
      label: item.formatted_number,
      variant: EnumDropdownItemVariant.Custom,
      renderOption: () => {
        return renderContent(false)
      },
      className: styles.dropdown,
      parentTooltipProps: tooltipProps,
      disabled: disabled,
    }

    if (InputCheckboxProps) {
      return (
        <InputCheckbox
          {...InputCheckboxProps}
          customLabel={renderContent(true)}
          tooltipProps={tooltipProps}
          disabled={disabled}
        />
      )
    }

    return (
      <DropdownCard
        item={dropdown}
        ariaLabel={ariaLabel}
        onChange={() => {
          if (onChange) onChange(item)
        }}
      />
    )
  }
)
